module.exports = __webpack_public_path__ + "media/images/icons/it-2b31e5a9b8b01c282c2bd29d19aeb338.svg";